import { useEffect, useState } from "react";
import { ComponentStyles } from "../../../helpers/constants/styles";
import classnames from "classnames";
import { ButtonProps } from "./Button";

type ToggleButtonProps = {
  toggledOn?: boolean;
  onToggle?: (isOn: boolean) => void;
} & ButtonProps;

function ToggleButton({
  toggledOn = false,
  onToggle,
  children,
  className,
  rounded,
  ...props
}: ToggleButtonProps) {
  const [isOn, setIsOn] = useState(toggledOn);

  const handleClick = () => {
    const newIsOn = !isOn;
    setIsOn(newIsOn);
    if (onToggle) {
      onToggle(newIsOn);
    }
  };

  useEffect(() => {
    setIsOn(toggledOn);
  }, [toggledOn]);

  return (
    <button
      {...props}
      className={classnames(
        "box-border transition-colors",
        rounded === "full" && "!rounded-full",
        isOn && ComponentStyles[props.theme ?? "primary"],
        !isOn && ComponentStyles[`${props.theme ?? "primary"}_off`],
        className,
      )}
      onClick={handleClick}
    >
      {children}
    </button>
  );
}

export default ToggleButton;
